let baseURL, apiURL, appURL;

if (process.env.CONFIG_ENV === 'master') {
  baseURL = 'https://api.welltory.com';
  apiURL = 'https://api.welltory.com';
  appURL = 'https://app.welltory.com';
}
else {
  baseURL = 'https://stage-api.welltory.com';
  apiURL = 'https://stage-api.welltory.com';
  appURL = 'https://stage-app.welltory.com';
}

export { baseURL, apiURL, appURL };
